import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store/rootReducer';
import moment from 'moment';
// SEE-1232 row h: both reads go to CDK. The superseded Amplify documents stay in
// graphql/queries (SEE-1238 removes them).
import { cardService } from 'app/services/card.service';

export interface TopMerchantsWidgetState {
  merchants: any[];
  merchantCategories: Array<{
    paidolId: string;
    authPaidolId: string;
    yearAndMonth: string;
    category: string;
    amount?: number | null;
    transactionCount?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
}

export const initialState: TopMerchantsWidgetState = {
  merchants: [],
  merchantCategories: [],
};

export const getTopMerchants = createAsyncThunk(
  'cards/topMerchantsWidget/getTopMerchants',
  async (paidolId: string) => {
    // Transport flip only. `yearAndMonthAmount: { beginsWith: { yearAndMonth } }` becomes
    // `yearAndMonth`; the server applies the same `YYYY-MM#` prefix. Same limit, same order.
    return cardService.listBudgetSpendByMonthAndMerchantByAmount<
      TopMerchantsWidgetState['merchants'][number]
    >({
      paidolId,
      yearAndMonth: moment().utc().format('YYYY-MM'),
      limit: 5,
      sortDirection: 'DESC',
    });
  }
);

export const getTopMerchantCategories = createAsyncThunk(
  'cards/topMerchantsWidget/getTopMerchantCategories',
  async (paidolId: string) => {
    return cardService.listBudgetSpendByMonthAndCategoryByAmount<
      TopMerchantsWidgetState['merchantCategories'][number]
    >({
      paidolId,
      yearAndMonth: moment().utc().format('YYYY-MM'),
      limit: 5,
      sortDirection: 'DESC',
    });
  }
);

const topMerchantsWidgetSlice = createSlice({
  name: 'cards/topMerchantsWidget',
  initialState,
  reducers: {
    resetTopMerchantsWidgetSlice: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getTopMerchants.fulfilled, (state, action) => {
      state.merchants = action.payload;
    });
    builder.addCase(getTopMerchantCategories.fulfilled, (state, action) => {
      state.merchantCategories = action.payload;
    });
  },
});

export const { resetTopMerchantsWidgetSlice } = topMerchantsWidgetSlice.actions;

export const selectTopMerchantsWidgetSlice = (state: RootState): TopMerchantsWidgetState =>
  state?.cards?.topMerchantsWidget ?? initialState;

export default topMerchantsWidgetSlice.reducer;
